module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "UniswapV2LiquidityPoolAbstraction",
	"sourceName": "contracts/levels/DiscoLP.sol",
	"abi": [],
	"bytecode": "0x60566023600b82828239805160001a607314601657fe5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220a949a6bccbfb553a7d994a094333fa2a3e2dfd22af01d6c6620616d80d7785f164736f6c634300060c0033",
	"deployedBytecode": "0x73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220a949a6bccbfb553a7d994a094333fa2a3e2dfd22af01d6c6620616d80d7785f164736f6c634300060c0033",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/DiscoLP.sol/UniswapV2LiquidityPoolAbstraction.json
// module id = 1541
// module chunks = 0